import React, { useState, useCallback, useEffect } from 'react';
import { SprayProgram, SprayProduct, sprayService } from '../../services/sprayService';
import SprayProgramList from './SprayProgramList';
import SprayProgramForm from './SprayProgramForm';

type View = 'list' | 'program-form';

const SprayProgramsPage: React.FC = () => {
  const [view, setView] = useState<View>('list');
  const [editProgram, setEditProgram] = useState<SprayProgram | undefined>();
  const [refreshKey, setRefreshKey] = useState(0);
  const [products, setProducts] = useState<SprayProduct[]>([]);

  useEffect(() => {
    sprayService.getProducts().then(setProducts).catch(() => {});
  }, []);

  const goList = useCallback(() => {
    setView('list');
    setEditProgram(undefined);
  }, []);

  const handleProgramSaved = useCallback(() => {
    setRefreshKey(k => k + 1);
    goList();
  }, [goList]);

  const handleClone = useCallback(async (programId: string) => {
    try {
      await sprayService.cloneProgram(programId);
      setRefreshKey(k => k + 1);
    } catch { /* list refresh will show current state */ }
  }, []);

  const handleUnlock = useCallback(async (programId: string) => {
    try {
      await sprayService.unlockProgram(programId);
      setRefreshKey(k => k + 1);
    } catch { /* list refresh will show current state */ }
  }, []);

  const handleRestore = useCallback(async (programId: string) => {
    try {
      await sprayService.restoreProgram(programId);
      setRefreshKey(k => k + 1);
    } catch { /* list refresh will show current state */ }
  }, []);

  if (view === 'program-form') {
    return (
      <SprayProgramForm
        program={editProgram}
        onSave={handleProgramSaved}
        onCancel={goList}
      />
    );
  }

  return (
    <SprayProgramList
      key={refreshKey}
      onNewProgram={() => setView('program-form')}
      onEditProgram={program => {
        setEditProgram(program);
        setView('program-form');
      }}
      onCloneProgram={handleClone}
      onUnlockProgram={handleUnlock}
      onRestoreProgram={handleRestore}
      products={products}
    />
  );
};

export default SprayProgramsPage;
